import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle, CheckCircle2, TrendingUp } from 'lucide-react';
import './QuestionEvaluationCard.css';

const QuestionEvaluationCard = ({ 
  question, 
  questionEvaluation, 
  questionScore,
  onNext 
}) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';
  
  if (!questionEvaluation || questionScore === null || questionScore === undefined) {
    return null;
  }

  const isSuccess = questionScore >= 6.0;
  
  // Format sub-scores for display
  const subScores = [
    { label: t('recordingQuestion.evaluation.answerQuality'), value: questionEvaluation.answer_quality },
    { label: t('recordingQuestion.evaluation.structure'), value: questionEvaluation.structure },
    { label: t('recordingQuestion.evaluation.clarity'), value: questionEvaluation.clarity },
    { label: t('recordingQuestion.evaluation.relevance'), value: questionEvaluation.relevance },
    { label: t('recordingQuestion.evaluation.depth'), value: questionEvaluation.depth }
  ].filter(item => item.value !== null && item.value !== undefined);

  if (isSuccess) {
    // Success state - this will be handled by QuestionSuccessModal
    // This component is for inline display only
    return null;
  }

  // Needs improvement - inline note
  return (
    <div className={`questionEvaluationCard questionEvaluationCard--needsImprovement ${isRTL ? 'questionEvaluationCard--rtl' : ''}`}>
      <div className="questionEvaluationCard__header">
        <AlertCircle className="questionEvaluationCard__icon" size={20} />
        <h3 className="questionEvaluationCard__title">
          {t('recordingQuestion.evaluation.needsImprovement')}
        </h3>
      </div>
      
      <div className="questionEvaluationCard__score">
        <span className="questionEvaluationCard__scoreValue">{questionScore.toFixed(1)}</span>
        <span className="questionEvaluationCard__scoreLabel">/10</span>
      </div>
      
      {questionEvaluation.feedback && (
        <p className="questionEvaluationCard__feedback">
          {questionEvaluation.feedback}
        </p>
      )}
      
      {subScores.length > 0 && (
        <div className="questionEvaluationCard__subScores">
          <div className="questionEvaluationCard__subScoresTitle">
            {t('recordingQuestion.evaluation.breakdown')}
          </div>
          <div className="questionEvaluationCard__subScoresList">
            {subScores.map((item, index) => (
              <div key={index} className="questionEvaluationCard__subScoreItem">
                <span className="questionEvaluationCard__subScoreLabel">{item.label}</span>
                <span className="questionEvaluationCard__subScoreValue">{item.value.toFixed(1)}</span>
              </div>
            ))}
          </div>
        </div>
      )}
      
      <div className="questionEvaluationCard__tip">
        <TrendingUp size={16} />
        <span>{t('recordingQuestion.evaluation.tip')}</span>
      </div>
    </div>
  );
};

export default QuestionEvaluationCard;






